import { render, staticRenderFns } from "./PeselSearchShowPopup.vue?vue&type=template&id=c1603e9a&"
import script from "./PeselSearchShowPopup.vue?vue&type=script&lang=js&"
export * from "./PeselSearchShowPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports